import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import { fetchCarConditionsIfNeeded } from '../../redux/helpers/carConditions';
import styles from './UnlockLockImmobilizerButton.styles';
import {
  selectCarConditions,
  selectUnlockingCar,
  selectSelectedCar,
  lockCarImmobilizerIfNeeded,
  unlockImmobilizerCarIfNeeded,
} from '../../redux/store/userData/cars';
import { selectToken } from '../../redux/store/userData/user';
import { useIntl } from 'react-intl';

const UnlockLockImmobilizerButton: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const token = useSelector(selectToken);
  const selectedCar = useSelector(selectSelectedCar);
  const unlocking = useSelector(selectUnlockingCar);
  const conditions = useSelector(selectCarConditions);
  const [isCarLocked, setIsCarLocked] = React.useState(
    conditions === null ? false : conditions.immobilizerLocked
  );

  React.useEffect(() => {
    if (conditions) {
      setIsCarLocked(conditions.immobilizerLocked);
    }
  }, [conditions]);

  const handleLockCar = (e: any) => {
    e.preventDefault();
    dispatch(lockCarImmobilizerIfNeeded(token, selectedCar?.id!));
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      400
    );
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      3000
    );
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      10000
    );
  };

  const handleUnlockCar = (e: any) => {
    e.preventDefault();
    dispatch(unlockImmobilizerCarIfNeeded(token, selectedCar?.id!));
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      400
    );
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      3000
    );
    setTimeout(
      () =>
        dispatch(
          fetchCarConditionsIfNeeded(token, selectedCar?.id!, false, true)
        ),
      10000
    );
  };

  return (
    <div className="buttons-wrapper">
      <Button
        className="lock button"
        block={true}
        onClick={handleLockCar}
        loading={isCarLocked ? false : unlocking}
        style={!isCarLocked ? { color: '#ee4e4e', borderColor: '#ee4e4e' } : {}}
        disabled={isCarLocked}
      >
        {intl.formatMessage({
          id: 'fleetadmin.immobilizer.lock',
        })}
      </Button>
      <Button
        className="unlock button"
        block={true}
        onClick={handleUnlockCar}
        loading={isCarLocked ? unlocking : false}
        style={isCarLocked ? { color: '#ee4e4e', borderColor: '#ee4e4e' } : {}}
        disabled={!isCarLocked}
      >
        {intl.formatMessage({
          id: 'fleetadmin.immobilizer.unlock',
        })}
      </Button>
      <style jsx>{styles}</style>
    </div>
  );
};

export default UnlockLockImmobilizerButton;
